export const STYLE = {
  width: '100%',
} as const;

export const CONTENT_CONTAINER_STYLE = {
  minWidth: '100%',
} as const;
